import { Injectable } from '@angular/core';

@Injectable()
export class GlobalServiceProvider {

  public boolMenu: boolean;

  private accessUrl: string;
  private userpass: string;
  private empresa: string;
  private fullCompany: any;
  private maskSlab: string;

  constructor() {
    this.boolMenu = false;
  }

  setAccessUrl(value: string) {
    this.accessUrl = value;
  }

  getAccessUrl() {
    return this.accessUrl;
  }

  setUserPass(value: string) {
    this.userpass = btoa(value);
  }

  getUserPass() {
    return this.userpass;
  }

  setEmpresa(value: string) {
    this.empresa = value;
  }

  getEmpresa() {
    return this.empresa;
  }

  setMaskSlab(value: string) {
    this.maskSlab = value;
  }

  getMaskSlab() {
    return this.maskSlab;
  }

  getMaskLen(m: string) {
    let cont: number = 0;
    let mask: string[] = this.getMaskSlab().split('');

    mask.forEach((char: string)=>{
      if(char === m){
        cont++
      }
    })

    return cont;
  }

  getFullCompany(){
    return this.fullCompany
  }

  setFullCompany(fullCompany: any){
    this.fullCompany = fullCompany
  }

}



// WEBPACK FOOTER //
// ./src/providers/global-service.ts